const formalMen = [
  { title: "Blazers", icon: "icon1", subcategories: [] },
  { title: "Shirts", icon: "icon2", subcategories: [] },
  { title: "Suits", icon: "icon2", subcategories: [] },
  { title: "Dress Pants", icon: "icon2", subcategories: [] },
  { title: "Tuxedos", icon: "icon2", subcategories: [] },
  { title: "Vests", icon: "icon2", subcategories: [] },
];
export default formalMen;
